<div class="motivationPartialView-contentContainer" [ngStyle]="{'direction':isRTL?'rtl':'ltr'}">
    @if(motivationDetails){
        <div class="motivationPartialView-topPart" [ngClass]="{'is-mobile-view': isMobileView}" [ngStyle]="{'background-color': motivationDetails.color}"> 
            <mat-icon class="motivationPartialView-motivationIcon" [ngClass]="{'is-mobile-view': isMobileView}">{{motivationDetails.imageUrl}}</mat-icon>
            <span class="motivationPartialView-motivationName" [ngClass]="{'is-mobile-view': isMobileView}">{{motivationDetails.name}}</span>
        </div>
    
        <div class="motivationPartialView_videoContainer">
            <iframe 
              width="560" 
              height="315" 
              [src]="motivationDetails.videoUrl | safeUrl"
              title="YouTube video player" 
              frameborder="0" 
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
              allowfullscreen>
            </iframe>
          </div>
          
    
        <div class="motivationPartialView-textContent">           
            <span *ngFor="let currLine of descriptionTextParts" [ngClass]="{'motivationPartialView-descriptionHeader': currLine.isHeader, 'motivationPartialView-descriptionText' : !currLine.isHeader}">
                <br *ngIf="currLine.isHeader">
                {{currLine.text}}
                <br/>
            </span>
        </div>   
    }
</div>
